import { resolve, ImResponse, messDoorClient } from 'services/api';
import { Category, ItemV5, Params, KeywordType, SearchProps, SearchScene } from './types';

export const getCategoryList = (
  params?: Pick<SearchProps, 'scene' | 'knowledgeId' | 'includeSpuClassId'>,
) => {
  return resolve<{
    categoryList: Category[];
  }>(messDoorClient.get('/item/v1/category/search', { params }));
};

type ItemV5ListResponse = {
  itemList: ItemV5[];
  pageInfo: {
    pageNo: number;
    pageSize: number;
    totalCount: number;
  };
  countExistKnowledge: number;
};

export function queryItemListV5(params: Params) {
  return resolve<ItemV5ListResponse>(messDoorClient.post('/item/v5/items/search', params));
}
export function queryItemListByKeywordV5({
  keyword,
  keywordType,
  platformStoreScope,
  scene,
  knowledgeId,
}: {
  keyword: string;
  keywordType: KeywordType;
  platformStoreScope?: General.StoreScope[];
  scene?: SearchScene;
  knowledgeId?: number;
}) {
  const params = {
    keywordType,
    keyword,
    pageNo: 1,
    pageSize: 9999,
    platformStoreScope: platformStoreScope || [],
    tagId: [],
    scene,
    knowledgeId,
  };
  return resolve<ItemV5ListResponse>(messDoorClient.post('/item/v5/items/search', params));
}

export function infiniteQueryItemListV5(params: Omit<Params, 'pageNo' | 'pageSize'>) {
  const result: ItemV5[] = [];
  const fetchByPage = (
    page: number,
    resolve: (value: ItemV5[]) => void,
    reject: (reason?: any) => void,
  ) => {
    const newParams = {
      ...params,
      pageNo: page,
      pageSize: 100,
    };
    messDoorClient
      .post<ImResponse<ItemV5ListResponse>>('/item/v5/items/search', newParams)
      .then((res) => {
        const { itemList, pageInfo } = res.data.data;
        result.push(...itemList);
        if (pageInfo.pageNo * 100 < pageInfo.totalCount) {
          fetchByPage(pageInfo.pageNo + 1, resolve, reject);
        } else {
          resolve(result);
        }
      })
      .catch(reject);
  };
  return new Promise<ItemV5[]>((resolve, reject) => {
    return fetchByPage(1, resolve, reject);
  });
}

export function queryItemListBySellerSkuV5(sellerSku: string) {
  const params = {
    keywordType: 4,
    keyword: sellerSku,
    pageNo: 1,
    pageSize: 9999,
    platformStoreScope: [],
    tagId: [],
  };
  return resolve<ItemV5ListResponse>(messDoorClient.post('/item/v5/items/search', params));
}
